var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonGiftCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -1440.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Gift-card",
    transform: "translate(1206.000000, 1440.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,12.4 C18,13.726 16.925,14.8 15.6,14.8 L13.2,14.8 L13.2,12.4 C13.2,11.075 14.274,10 15.6,10 L18,10 L18,12.4 Z M18,22 L15.6,22 C14.274,22 13.2,20.926 13.2,19.6 L13.2,17.2 L15.6,17.2 C16.925,17.2 18,18.275 18,19.6 L18,22 Z M10.8,14.8 L8.4,14.8 C7.075,14.8 6,13.726 6,12.4 L6,10 L8.4,10 C9.726,10 10.8,11.075 10.8,12.4 L10.8,14.8 Z M10.8,19.6 C10.8,20.926 9.726,22 8.4,22 L6,22 L6,19.6 C6,18.275 7.075,17.2 8.4,17.2 L10.8,17.2 L10.8,19.6 Z M19.459,14.5 L32,14.5 L32,8 C32,6.35 30.65,5 29,5 L8.177,5 L9.795,8.236 C9.356,8.088 8.889,8 8.4,8 L6.323,8 L4.823,5 L3,5 C1.35,5 0,6.35 0,8 L0,14.5 L4.541,14.5 C4.869,15.097 5.329,15.611 5.884,16 C5.329,16.389 4.869,16.903 4.541,17.5 L0,17.5 L0,24 C0,25.65 1.35,27 3,27 L15.823,27 L14.205,23.764 C14.644,23.912 15.111,24 15.6,24 L17.678,24 L19.178,27 L29,27 C30.65,27 32,25.65 32,24 L32,17.5 L19.459,17.5 C19.132,16.903 18.671,16.389 18.116,16 C18.671,15.611 19.132,15.097 19.459,14.5 L19.459,14.5 Z",
    id: 208
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonGiftCard);
export default __webpack_public_path__ + "static/media/common-gift-card.29c33c18.svg";
export { ForwardRef as ReactComponent };